import { __rest } from '../../../_virtual/_tslib.js';
import React__default from 'react';
import { Cell } from '../styles.js';
import { defaultProps } from '../defaultProps.js';

function TableCell(_a) {
    var { children, textAlign = defaultProps.textAlign, variant = defaultProps.variant, colSpan = defaultProps.colSpan } = _a, rest = __rest(_a, ["children", "textAlign", "variant", "colSpan"]);
    return (React__default.createElement(Cell, Object.assign({}, rest, { align: textAlign, variant: variant, colSpan: colSpan }), children));
}

export { TableCell };
